import type { FAQItem } from '../seo/FAQSchema';

/** Multi-channel page FAQs — shared by on-page UI and FAQPage JSON-LD in <head>. */
export const MULTI_CHANNEL_FAQS: FAQItem[] = [
  {
    question: 'What is multi‑channel fulfilment?',
    answer:
      'Managing orders from multiple platforms in one warehouse with unified SLAs, inventory and reporting — core ecommerce fulfilment for brands selling on more than one channel. One stock pool, many channels.',
  },
  {
    question: 'Which platforms do you support?',
    answer:
      'We support Amazon FBA, Shopify, eBay and TikTok Shop — plus 650+ integrations via our WMS and middleware where needed.',
  },
  {
    question: 'How are orders routed?',
    answer:
      'Orders sync in real time and are auto‑routed by SLA, weight, dimensions and destination to choose the optimal label per order.',
  },
  {
    question: 'Can I manage inventory centrally?',
    answer:
      'Yes. A single dashboard controls stock, back‑orders, quarantines and cycle counts across all channels.',
  },
  {
    question: 'Do you provide real‑time tracking?',
    answer:
      'Yes. Tracking is pushed back to each platform immediately after label generation to protect your metrics and customer comms.',
  },
  {
    question: 'How fast is onboarding for multi‑channel?',
    answer:
      'Typically a few working days once SKUs are mapped, shipping rules are set and first stock is received.',
  },
];
